import { render } from "./GroupContant.vue?vue&type=template&id=4bfedf63"
import script from "./GroupContant.vue?vue&type=script&lang=js"
export * from "./GroupContant.vue?vue&type=script&lang=js"

import "./GroupContant.vue?vue&type=style&index=0&id=4bfedf63&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__